import { CURRENCY_PLACEHOLDER, PRICE_PLACEHOLDER } from '@/scripts/constants/placeholders'
import wcs from '@/scripts/libs/wcs'
import { WcsLocales } from '@/scripts/libs/wcs/types/locales'

export const sumPrices = (first: string, second: string): undefined | string => {
  if (!first || !second) {
    return undefined
  }

  // TODO: check if a simple * 100 / 100 is enough
  return (
    (Number(parseFloat(first.replace(/,/g, '')).toFixed(2).split('.').join('')) +
      Number(parseFloat(second.replace(/,/g, '')).toFixed(2).split('.').join(''))) /
    100
  ).toFixed(2)
}

export const parsePrice = (price: string) => {
  return parseFloat(price).toFixed(2)
}

export const arePricesDifferent = (offerPrice: string, listPrice: string): boolean => {
  return !!offerPrice && parsePrice(offerPrice) !== parsePrice(listPrice)
}
export const formatPriceForJapan = (price: string) => {
  if (price.length > 8) {
    const splitPrice = price.slice(0, price.indexOf('.'))
    const strLength = splitPrice.length
    if (strLength > 3) {
      const firstPart = splitPrice.slice(0, strLength - 3)
      const secondPart = splitPrice.slice(-3)
      return firstPart + ',' + secondPart
    }
    return price
  } else {
    return price
  }
}

// TODO: move function inside pdp.ts
export const formatPriceForPDP = (priceFormat: string, currencySymbol: string, price: string) => {
  if (!priceFormat || !currencySymbol || !price) {
    return ''
  }

  const formattedPrice = priceFormat
    ?.replace(CURRENCY_PLACEHOLDER, currencySymbol)
    ?.replace(PRICE_PLACEHOLDER, price)
  return formattedPrice
}

export const formatPrice = (
  price: string | number,
  priceFormat: string,
  currencySymbol: string
): string => {
  if (isNaN(Number(price))) {
    return String(price)
  }

  const { locale, currency } = wcs.getStoreConfig()

  const localeModified = locale === WcsLocales.FR_CA ? WcsLocales.EN_CA : locale

  try {
    const value = new Intl.NumberFormat(localeModified, {
      style: 'currency',
      currency,
    })
      .formatToParts(Number(price))
      .map((p) => (p.type != 'literal' && p.type != 'currency' ? p.value : ''))
      .join('')

    return formatPriceForPDP(priceFormat, currencySymbol, value)
  } catch (e) {
    return String(price)
  }
}
